import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/Index.vue";

import HomeRouter from "./modules/home";
import QuestionRouter from "./modules/question";
import CommunityRouter from "./modules/community";
import ActivityRouter from "./modules/activity";
import UserRouter from "./modules/user";
import OtherRouter from "./modules/other";
import AiRouter from "./modules/ai"

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "/",
    component: Layout,
    redirect: "/home",
    children: [
      ...HomeRouter,
      ...UserRouter,
      ...QuestionRouter,
      ...CommunityRouter,
      ...ActivityRouter,
      ...AiRouter,
      ...OtherRouter,
    ],
  },

  {
    path: "/401",
    name: "401",
    component: () => import("@/views/error/401.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/error/404.vue"),
  },
  {
    path: "*",
    redirect: "/404",
  },
];
const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
export default router;
